export const API_GET_SCC_SUPPLIER_QUOTATION_LIST = {
  url: 'supplier/quotation/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 导入*/
export const API_GET_SCC_SUPPLIER_QUOTATION_IMPORT = {
  url: 'supplier/quotation/import',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 提交*/
export const API_GET_SCC_SUPPLIER_QUOTATION_COMMIT = {
  url: 'supplier/quotation/commit',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 导出*/
export const API_GET_SCC_SUPPLIER_QUOTATION_EXPORT = {
  url: 'supplier/quotation/export',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 修改*/
export const API_GET_SCC_SUPPLIER_QUOTATION_EDIT = {
  url: 'supplier/quotation/edit',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 商品*/
export const API_LIKE_PRODUCT_LIST = {
  url: 'public/simple/product/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 商品*/
export const API_IMPORT_EXCEL_TEMLATE = {
  url: 'import/excel/template',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};
export const API_POST_PAYMENT_GETPAYMENTBYSTATEMENTNO = {
  url: 'payment/getPaymentByStatementNo',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

// 开票信息
export const API_GET_API_COMPANY_LIST = {
  url: 'api/company/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};
